import { from, fromEvent, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from '../../Lib/Helper/I18nHelper';
import { AxDropdown, IAxDropdownOptions } from "@axess/limestone";
import { inputMaskHelper } from '../../Lib/Helper/InputMaskHelper';

@ModuleName("SeasonCardBooking")
export class SeasonCardBooking implements AxInit {
    private InitData: ReservationsInitData;

    private txtSerial: HTMLInputElement;
    private txtPosNr: HTMLInputElement;
    private txtWtp: HTMLInputElement;
    private btnNext: HTMLButtonElement;
    private linkPopup: HTMLLinkElement;

    private txtSerialChange$: Observable<InputEvent>;
    private txtPosNrChange$: Observable<InputEvent>;
    private linkChange$: Observable<InputEvent>;

    public ProjectNr: number;
    public PosNr: number;
    public SerialNr: number;
    public NextUrl: string;
    private formValidator: FormValidator;

    protected seasonCardDropdown: AxDropdown = new AxDropdown();

    constructor(private _i18nHelper = new I18nHelper) { }

    AxInit(init: any): void {
        this.InitData = init;

        this.txtSerial = document.getElementById('serialNr') as HTMLInputElement;
        this.txtPosNr = document.getElementById('posNr') as HTMLInputElement;
        this.txtWtp = document.getElementById('wtpInput') as HTMLInputElement;
        this.btnNext = document.getElementById('spb_enter_button') as HTMLButtonElement;
        this.linkPopup = document.getElementById('popupDesc') as HTMLLinkElement;

        this.formValidator = new FormValidator();

        this.formValidator.setValidationMessages("projNr", "msgProjNr", {
            valueMissing: this._i18nHelper.GetTranslation(Translations.ValueMissing),
            patternMismatch: this._i18nHelper.GetTranslation(Translations.OnlyNumbers),
        }, this.btnNext);


        this.formValidator.setValidationMessages("posNr", "msgPosNr", {
            valueMissing: this._i18nHelper.GetTranslation(Translations.ValueMissing),
            patternMismatch: this._i18nHelper.GetTranslation(Translations.OnlyNumbers),
        }, this.btnNext);

        this.formValidator.setValidationMessages("serialNr", "msgSerialNr", {
            valueMissing: this._i18nHelper.GetTranslation(Translations.ValueMissing),
            patternMismatch: this._i18nHelper.GetTranslation(Translations.OnlyNumbers),
        }, this.btnNext);

        $('#spb_enter_button').click(x => {
            let projNr = $('#projNr').val();
            let posNr = $('#posNr').val();
            let serialNr = $('#serialNr').val();

            this.submitInput(projNr, posNr, serialNr);
        });

        $(".chip-card-sample-close").click(function () {
            $(".ax-resportal-card-example-holder").hide();
        });

        $('input:radio[name=flexRadioDefault]').change(() => {
            this.seasonCardDropdown.resetSelection();
            this.resetSelection();
        });

        this.txtSerialChange$ = fromEvent<InputEvent>(this.txtSerial, 'input');
        this.txtPosNrChange$ = fromEvent<InputEvent>(this.txtPosNr, 'input');
        this.linkChange$ = fromEvent<InputEvent>(this.linkPopup, 'click');
        this.linkPopup.addEventListener('click', (e: Event) => this.showExample('exampleHoler_1'));

        this.seasonCardDropdown.init(`.seasonPassReservation__product-dropdown`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: ($parent: JQuery<HTMLElement>) => {
                    $('input:radio[name=flexRadioDefault]').prop('checked', false);
                    $('#collapse_1').collapse('hide');
                    $('#collapse_2').collapse('hide');
                    this.resetSelection();
                }
            });
        this.setSeasonPassDropDownObserver();

        let maskOptions = inputMaskHelper.wtpMaskOptions();
        maskOptions.oncomplete = () => {
            AxessViewer.loadPartialView('/Reservations/CheckWtp', { wtp: $(this.txtWtp).val() }, (result) => {
                if (result.success) {
                    this.ProjectNr = result.proj;
                    this.PosNr = result.pos;
                    this.SerialNr = result.serie;
                    this.NextUrl = `/${this.InitData.Language}/Reservations/Reserved?ProjNr=${this.ProjectNr}&PosNr=${this.PosNr}&SerialNr=${this.SerialNr}`;

                    this.btnNext.disabled = false;

                    $('#msgWtpInput').html('');
                }
                else {
                    this.btnNext.disabled = true;
                    $('#msgWtpInput').html(this._i18nHelper.GetTranslation(Translations.NotValidWtp));
                }
            }, {
                silent: false
            });
        };

        $(this.txtWtp).inputmask({
            mask: inputMaskHelper.wtpNumberMask(),
            ...maskOptions
        });

        this.setSerialInputObservers();
        this.setPosNoInputObservers();

        this.btnNext.disabled = true;

        //QR stuff

  //      let html5QrcodeScanner = new Html5QrcodeScanner(
  //          "reader",
  //          { fps: 10, qrbox: { width: 250, height: 250 } },
  ///* verbose= */ false);
  //      html5QrcodeScanner.render(this.onScanSuccess, this.onScanFailure);
    }

    onScanSuccess(decodedText, decodedResult) {
        let that = this;
        $('#cameraModal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();


        AxessViewer.loadPartialView('/Reservations/CheckScanedWtp', { wtp: decodedText }, function (result) {
            if (result.success) {

                that.btnNext.disabled = false;
            }
            else {
                $('.loading-spinner.loading').hide();
                $('#wtpInput').val(result.wtpNr);
                $('#msgWtpInput').html(this._i18nHelper.GetTranslation(Translations.NotValidWtp));
            }
        }, {
            silent: true,

        });
    }

    resetSelection() {
        this.btnNext.disabled = true;
        $('#posNr').val('');
        $('#serialNr').val('');
        $(this.txtWtp).val('');
    }

    onScanFailure(error) {
        console.warn(`Code scan error = ${error}`);
    }

    setSerialInputObservers() {
        this.txtSerialChange$
            .pipe(map((event: InputEvent) => (event.target as HTMLInputElement).value))
            .subscribe((sp) => {

                let projNr = $('#projNr').val();
                let posNr = $('#posNr').val();
                let serialNr = $('#serialNr').val();

                if (/*sp.length < 5 ||*/ this.isEmpty(posNr)) {
                    return;
                }

                this.checkSerialNo(projNr, posNr, serialNr);
            });
    }

    setPosNoInputObservers() {
        this.txtPosNrChange$
            .pipe(map((event: InputEvent) => (event.target as HTMLInputElement).value))
            .subscribe((sp) => {

                let projNr = $('#projNr').val();
                let posNr = $('#posNr').val();
                let serialNr = $('#serialNr').val();

                if (/*sp.length < 3 || */this.isEmpty(serialNr)) {
                    return;
                }

                this.checkSerialNo(projNr, posNr, serialNr);
            });
    }

    showExample(elemId: string) {
        $('#' + elemId).show();
    }

    checkSerialNo(projNr, posNr, serialNr) {
        let data = {
            projNr: projNr,
            posNr: posNr,
            serialNr: serialNr
        }

        let that = this;
        if ($('#serialNr').val() == null || $('#serialNr').val() == '') {
            return;
        }

        if ($('#posNr').val() == null || $('#posNr').val() == '') {
            return;
        }

        AxessViewer.loadPartialView('/Reservations/CheckSerial', data, function (result) {
            if (result.success) {
                that.ProjectNr = result.proj;
                that.PosNr = result.pos;;
                that.SerialNr = result.serie;
                that.NextUrl = `/${that.InitData.Language}/Reservations/Reserved?ProjNr=${that.ProjectNr}&PosNr=${that.PosNr}&SerialNr=${that.SerialNr}`;

                that.btnNext.disabled = false;
            }
            else {
                that.btnNext.disabled = true;
                $('#msgSerialNr').html(that._i18nHelper.GetTranslation(Translations.NotValidSerialNumber));
            }
        }, {
            silent: false,
        });
    }

    setSeasonPassDropDownObserver() {
        this.seasonCardDropdown.getSelectObserver().subscribe((sp: string) => {
            if (sp != null && sp.length > 4) {
                $(".collapse").collapse("hide");
                $('input:radio[name=flexRadioDefault]').each(function () { $(this).prop('checked', false); });

                this.ProjectNr = parseInt(sp.split('-')[0]);
                this.PosNr = parseInt(sp.split('-')[1]);
                this.SerialNr = parseInt(sp.split('-')[2]);
                this.NextUrl = `/${this.InitData.Language}/Reservations/Reserved?ProjNr=${this.ProjectNr}&PosNr=${this.PosNr}&SerialNr=${this.SerialNr}`;
                this.btnNext.disabled = false;
            }
            else {
                this.btnNext.disabled = true;
            }
        });
    }

    submitInput(projNr, posNr, serialNr) {
        let url = `/${this.InitData.Language}/Reservations/Reserved?ProjNr=${projNr}&PosNr=${posNr}&SerialNr=${serialNr}`;

        if (this.NextUrl != null) {
            url = this.NextUrl;
        }

        window.location.href = url;
    }

    isEmpty(str) {
        return (!str || str.length === 0);
    }
}

interface ReservationsInitData {
    Language: string;
}

type ValidationMessages = Partial<Record<'valueMissing' | /*'tooShort' | 'tooLong' | 'rangeUnderflow' | 'rangeOverflow' | 'typeMismatch' |*/ 'patternMismatch', string>>;

class FormValidator {
    public isOk: boolean = true;
    public setValidationMessages(ctrlID: string, msgEleID: string, messages: ValidationMessages, btnNext: HTMLButtonElement) {

        let element: any = document.querySelector("#" + ctrlID);

        element.addEventListener("input", (evt) => {
            let flag: boolean;
            this.isOk = true;
            if (element.validity.valueMissing) {
                if (typeof messages.valueMissing !== "undefined") {
                    element.setCustomValidity(messages.valueMissing);
                    flag = true;
                    this.isOk = false;
                }
            }

            if (element.validity.patternMismatch) {
                if (typeof messages.patternMismatch !== "undefined") {
                    element.setCustomValidity(messages.patternMismatch);
                    flag = true;
                    this.isOk = false;
                }
            }

            if (flag) {
                document.querySelector("#" + msgEleID).innerHTML = element.validationMessage;
                btnNext.disabled = true;
                this.isOk = false;
            }
            else {
                element.setCustomValidity("");
                document.querySelector("#" + msgEleID).innerHTML = "";
                //btnNext.disabled = false;
                this.isOk = true;
            }
        });
    }
}
